import { PackagingComponentDto } from "./packaging-component-dto";

export class DecorationDto extends PackagingComponentDto { }